/**Dependencies */
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

/**Componentes */
import { Row, Col, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";

/**Styles */
import "../styles/hotel.scss";
import "../styles/cardTours.scss";

/**Images */
import { FaStar } from "react-icons/fa";
import { FaCrown, FaLocationDot, FaMapLocation } from "react-icons/fa6";
import { Currency, FormatDate, totalPrices } from "../helpers";
import Skeleton from "react-loading-skeleton";
import imagePreview from "../images/preview.jpg";
import { comisionUser } from "../services/LoginService";
export const CardResultHotel = ({
  hotel,
  isExperiencies,
  isCollection,
  nights,
  totalPax,
  percentageMarkup,
  visibleHotels,
  selectHotel,
}) => {
  const [comisionUsuario, setComisionUsuario] = useState(0);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser") || 0)
  );
  const [totalNights, setTotalNights] = useState(0);
  const [showDates, setShowDates] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  useEffect(() => {
    const comision = async () => {
      try {
        if (userData?.usuario?.id) {
          const response = await comisionUser(userData?.usuario?.id);
          setComisionUsuario(response);
        } else {
          setComisionUsuario(0);
        }
      } catch (error) {
        throw new Error("error connection: " + error);
      }
    };

    comision();
  }, []);

  useEffect(() => {
    if (isCollection) {
      let checkInDate = "";
      let checkOutDate = "";

      if (queryParams.get("in") && queryParams.get("out")) {
        checkInDate = queryParams.get("in");
        checkOutDate = queryParams.get("out");
      } else {
        // Obtener las fechas de entrada y salida de la URL
        checkInDate = hotel.checkin;
        checkOutDate = hotel.checkout;
      }
      if (checkInDate && checkOutDate) {
        const checkIn = new Date(checkInDate);
        const checkOut = new Date(checkOutDate);
        const timeDifference = checkOut - checkIn;
        const nights = timeDifference / (1000 * 3600 * 24);

        setTotalNights(nights);
        setShowDates([checkInDate, checkOutDate]);
      }
    }
  }, [location.search]);
  const getStarCount = (categoria) => {
    const starMatch = categoria?.match(/^(\d+)/); // Busca el número al inicio de la cadena
    return starMatch ? parseInt(starMatch[1], 10) : 0; // Devuelve el número de estrellas
  };

  const HotelStars = ({ categoriaId }) => {
    const totalStars = 5; // Siempre queremos mostrar 5 estrellas
    const starCount = getStarCount(categoriaId); // Obtener el número de estrellas activas
    // Crear un arreglo de 5 estrellas, donde las primeras `starCount` sean destacadas y el resto en gris
    const stars = Array.from({ length: totalStars }, (_, index) =>
      index < starCount ? (
        <FaStar style={{ color: " #0044aa" }} key={index} />
      ) : (
        <FaStar style={{ color: " #000000ff" }} />
      )
    );

    return <div className="section-stars">{stars}</div>;
  };
  return (
    <>
      <div className="cards-hotels w-100 mt-3">
        {!isCollection ? (
          <Card
            className="shadow rounded-5 p-3 border-0 hotelCard"
            onClick={() => selectHotel(hotel)}
          >
            <Row>
              <Col lg={5} md={12} sm={12}>
                <img
                  src={
                    hotel?.imagenes?.[0]
                      ? `http://photos.hotelbeds.com/giata/bigger/${hotel?.imagenes?.[0]?.url}`
                      : imagePreview
                  }
                  alt=""
                  style={
                    comisionUsuario?.hoteleria
                      ? {
                          width: "100%",
                          height: "300px",
                          borderRadius: "15px",
                          objectFit: "cover",
                        }
                      : {
                          width: "100%",
                          height: "250px",
                          borderRadius: "15px",
                          objectFit: "cover",
                        }
                  }
                />
                {hotel?.tratoExclusivo === 1 && (
                  <div
                    className="special-price alojamientos"
                    id="special-price"
                  >
                    <Row>
                      <Col
                        lg={8}
                        className="d-flex align-items-center"
                        style={{ fontSize: "17px" }}
                      >
                        <span className="d-flex align-items-center p-2 fw-semibold">
                          <FaCrown style={{ marginRight: "2px" }} /> Destacados
                        </span>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
              <Col
                lg={4}
                md={12}
                sm={12}
                style={{ padding: "20px 20px 10px 20px", display: "grid" }}
              >
                <div className="name-hotel w-100 d-flex justify-content-between">
                  {hotel.categoria ? (
                    <div className="w-100">
                      <div className="d-flex justify-content-between align-items-center">
                        <h4
                          className="title-hotel m-0"
                          style={{ fontSize: "20px" }}
                        >
                          {hotel?.nombre}
                        </h4>
                      </div>
                      <p className="m-0">
                        {hotel?.categoriaId === "BOU" ? (
                          <span style={{ fontSize: "15px" }}>
                            {hotel?.categoria}
                          </span>
                        ) : (
                          <div className="star-category text-end d-flex align-items-baseline">
                            <span
                              className="mt-1 d-flex align-items-center"
                              style={{ fontSize: "20px", color: "#3864AB" }}
                            >
                              <HotelStars categoriaId={hotel?.categoria} />
                            </span>
                          </div>
                        )}
                      </p>
                      <p
                        className="text-muted pt-2 m-0"
                        style={{ fontSize: "14px" }}
                      >
                        {hotel?.direccion}
                      </p>
                      <div className="amenities pt-3">
                        <span className="text-secondary">
                          Plan de alimentos:
                        </span>
                        <br />
                        <span className="text-secondary">
                          {hotel?.habitaciones?.[0]?.rates?.[0]?.boardName}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="w-100">
                      <Skeleton count={4} className="d-block w-100" />
                    </div>
                  )}
                </div>
              </Col>
              <Col
                className="d-flex flex-column"
                lg={3}
                md={12}
                sm={12}
                style={{ padding: "20px 20px 10px 20px" }}
              >
                {hotel?.habitaciones?.[0]?.rates?.[0] ? (
                  <>
                    <span className="text-secondary text-end">
                      {nights > 1 ? `${nights} noches` : `${nights} noche`},{" "}
                      {totalPax > 1
                        ? `${totalPax} personas`
                        : `${totalPax} persona`}
                    </span>
                    {/* {hotel?.categoria ? (
                      <>
                        {hotel?.categoriaId === "BOU" ? (
                          <span style={{ fontSize: "15px" }}>
                            {hotel?.categoria}
                          </span>
                        ) : (
                          <div className="star-category text-end py-2 d-lg-flex d-none justify-content-end">
                            <span
                              className="mt-1 d-flex align-items-center"
                              style={{ fontSize: "20px", color: "#3864AB" }}
                            >
                              <FaStar />
                              <HotelStars categoriaId={hotel?.categoria} />
                              .0
                            </span>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <Skeleton count={1} className="w-100" />
                      </>
                    )} */}
                    <div className="text-end d-grid mt-3">
                      <p className="m-0">Precio total:</p>
                      <h5 className="text-rose" style={{ fontWeight: 600 }}>
                        {comisionUsuario?.hoteleria && (
                          <>
                            <span
                              style={{
                                fontSize: "17px",
                                color: "#8e8e8e",
                                textDecoration: "line-through",
                              }}
                            >
                              {Currency(
                                totalPrices(
                                  hotel?.habitaciones[0]?.rates[0]?.net,
                                  percentageMarkup,
                                  nights
                                )[1]
                              )}{" "}
                              MXN
                            </span>
                            <br />
                          </>
                        )}
                        {Currency(
                          totalPrices(
                            hotel?.habitaciones[0]?.rates[0]?.net,
                            percentageMarkup,
                            nights,
                            comisionUsuario?.hoteleria
                          )[1]
                        ) + " MXN"}
                      </h5>
                      <p className="m-0 text-muted">
                        Precio por noche:{" "}
                        {comisionUsuario?.hoteleria && (
                          <>
                            <br />
                            <span
                              style={{
                                fontSize: "15px",
                                color: "#8e8e8e",
                                textDecoration: "line-through",
                              }}
                            >
                              {Currency(
                                totalPrices(
                                  hotel?.habitaciones[0]?.rates[0]?.net,
                                  percentageMarkup,
                                  nights
                                )[0]
                              )}{" "}
                              MXN
                            </span>
                            <br />
                          </>
                        )}
                        {Currency(
                          totalPrices(
                            hotel?.habitaciones[0]?.rates[0]?.net,
                            percentageMarkup,
                            nights,
                            comisionUsuario?.hoteleria
                          )[0]
                        ) + " MXN"}
                      </p>
                      <p className="text-muted mt-1">* Impuestos incluidos</p>

                      {/* <div className="d-flex justify-content-end mt-2">
                   
                      <Button onClick={() => selectHotel(hotel)} className="btn-blue px-4 py-2 rounded-5 fw-semibold" style={{ width: "100%" }}>
                        Ver Detalles
                      </Button>
                    
                  </div> */}
                    </div>
                  </>
                ) : (
                  <>
                    <Skeleton count={6} className="w-100 my-2" />
                  </>
                )}
              </Col>
            </Row>
          </Card>
        ) : (
          <Card
            className="hotel-card shadow rounded-5 p-3 border-0"
            style={{ overflow: "hidden" }}
          >
            <Row>
              <Col lg={4} md={12} sm={12}>
                <img
                  src={`http://photos.hotelbeds.com/giata/bigger/${hotel?.img}`}
                  alt=""
                  style={{
                    width: "100%",
                    height: "220px",
                    borderRadius: "30px",
                    objectFit: "cover",
                  }}
                />
              </Col>
              <Col
                lg={8}
                md={12}
                sm={12}
                style={{ padding: "20px 20px 10px 20px", display: "grid" }}
              >
                <Row>
                  <Col
                    lg={12}
                    className="d-flex align-items-center"
                    style={{ fontSize: "17px" }}
                  >
                    <div className="name-hotel d-flex justify-content-between">
                      <div>
                        <h4
                          className="title-hotel"
                          style={{ fontSize: "25px" }}
                        >
                          {hotel?.name}
                        </h4>
                      </div>
                      <div className="star-category text-end py-2 d-lg-none d-flex align-items-baseline mx-3">
                        <span
                          className="d-flex align-items-center"
                          style={{ fontSize: "20px", color: "#3864AB" }}
                        >
                          {hotel?.category && (
                            <>
                              {hotel?.categoryId === "BOU" ? (
                                <>{hotel?.category}</>
                              ) : (
                                <>
                                  <HotelStars categoriaId={hotel?.category} />
                                </>
                              )}
                            </>
                          )}
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12} className="pt-1" style={{ fontSize: "17px" }}>
                    <Row>
                      <Col lg={4}>
                        <div>
                          <p>
                            {" "}
                            {hotel.zone}{" "}
                            <FaMapLocation
                              width={20}
                              style={{ marginLeft: "10px", color: "#3864AB" }}
                            />
                          </p>
                        </div>
                        <div className="star-category  d-lg-flex d-none">
                          <p
                            style={{
                              fontSize: "20px",
                              color: "#3864AB",
                              justifyContent: "center",
                              alignItems: "center",
                              margin: "0",
                              display: "flex",
                            }}
                          >
                            {hotel?.category && (
                              <>
                                {hotel?.categoryId === "BOU" ? (
                                  <>{hotel?.category}</>
                                ) : (
                                  <>
                                    <HotelStars categoriaId={hotel?.category} />
                                  </>
                                )}
                              </>
                            )}
                          </p>
                        </div>
                      </Col>

                      <Col lg={8}>
                        <div className="text-end d-grid">
                          <span style={{ fontSize: "13px", textAlign: "end" }}>
                            {hotel?.num_adults} Adulto(s) - {hotel?.num_minors}{" "}
                            Niño(s)
                          </span>
                          <span style={{ fontSize: "13px", textAlign: "end" }}>
                            {showDates[0]} al {showDates[1]}
                          </span>
                          <p className="m-0">Precio por noche</p>
                          <h5 className="text-rose" style={{ fontWeight: 600 }}>
                            {comisionUsuario?.hoteleria && (
                              <>
                                <span
                                  style={{
                                    fontSize: "15px",
                                    color: "#8e8e8e",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {Currency(
                                    totalPrices(
                                      hotel?.price,
                                      percentageMarkup,
                                      totalNights
                                    )[0]
                                  )}{" "}
                                  MXN
                                </span>
                                <br />
                              </>
                            )}
                            {Currency(
                              totalPrices(
                                hotel?.price,
                                percentageMarkup,
                                totalNights,
                                comisionUsuario?.hoteleria
                              )[0]
                            ) + " MXN"}
                          </h5>
                          <div className="d-flex justify-content-end mt-2">
                            {/* <Link */}
                            {/* to={isExperiencies ? "/info-experiencia" : "/info-hotel"} */}
                            {/* > */}
                            <Button
                              onClick={() => [
                                selectHotel(hotel),
                                window.scroll({
                                  top: 0,
                                  left: 0,
                                  behavior: "smooth",
                                }),
                              ]}
                              className="btn-blue px-4 w-auto py-2 rounded-5 fw-semibold"
                              style={{ width: "100%" }}
                            >
                              Ver Detalles
                            </Button>
                            {/* </Link> */}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        )}
      </div>
    </>
  );
};
